import { prolongationQuarterHourCounts } from 'components/b2b/ProlongationHandler/ProlongationHandlerContainer';
import { Booking } from 'shared-types/booking';
import { Slot } from 'shared-types/roomSlots';

import { add24Hours } from './handle24hours';

interface ExtensionPrice {
  price: number;
  time: number;
  minutes: number;
}

export const extensionPrices = (slot: Slot, booking: Booking): ExtensionPrice[] => {
  const { pricePerPerson: pricePerPersonPerHour, startHour, endHour } = slot;
  const { capacity } = booking;

  const maxDuration = add24Hours(endHour) - add24Hours(startHour);

  const times = [
    {
      minutes: 120,
      price: Math.round(pricePerPersonPerHour * 2),
    },
    {
      minutes: 60,
      price: Math.round(pricePerPersonPerHour),
    },
    {
      minutes: 30,
      price: Math.round(pricePerPersonPerHour / 2),
    },
  ];

  const prices: ExtensionPrice[] = [];

  times.forEach((time, index) => {
    if (time.minutes <= maxDuration) {
      prices.push({
        minutes: time.minutes,
        price: (time.price * capacity) / 100,
        time: prolongationQuarterHourCounts[index],
      });
    }
  });

  return prices;
};
